import { render, staticRenderFns } from "./PurchaseRelations.vue?vue&type=template&id=11c8cb5a&"
import script from "./PurchaseRelations.vue?vue&type=script&lang=js&"
export * from "./PurchaseRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports